/* ==========================================================================
   FLC Forge — Footer
   ========================================================================== */

const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

function initFooterAccordion(scope = document) {
  const toggles = scope.querySelectorAll('.footer__menu-toggle');

  toggles.forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      const submenu = document.getElementById(btn.getAttribute('aria-controls'));
      if (submenu) submenu.classList.toggle('hidden', expanded);
    });
  });

  syncFooterAccordion(scope);
}

function syncFooterAccordion(scope = document) {
  scope.querySelectorAll('.footer__sub-menu').forEach(submenu => {
    const btn = scope.querySelector(`[aria-controls="${submenu.id}"]`);
    if (!MOBILE_MQ.matches) {
      submenu.classList.remove('hidden');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    } else {
      const isOpen = btn?.getAttribute('aria-expanded') === 'true';
      submenu.classList.toggle('hidden', !isOpen);
    }
  });
}

MOBILE_MQ.addEventListener('change', () => syncFooterAccordion());

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFooterAccordion());
} else {
  initFooterAccordion();
}

document.addEventListener('shopify:section:load', event => {
  if (event.target.querySelector('.footer__menu-toggle')) {
    initFooterAccordion(event.target);
  }
});
